module.exports = __webpack_public_path__ + "static/homepage-desktop-dia-boutique-50e00103856d8c8735e4769dda941bb9.jpg";